import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { WelcomeViewComponent } from "./components";
import { Box1Component } from "../../layout/boxes";
import { NewChatBotComponent } from 'src/chatbot/chatbot.component';
import { ChatBotScriptService } from 'src/app/services';
import { WebsocketLaravelReverb } from './services';
import { CHANNEL_ATRIL_PANTALLA_NAME, GO_TO_HOME_PAGE_EVENT } from './config';
import { CustomRouteService } from 'src/app/pages/custom-route/services';
import { SayGoodByeViewComponent } from "./components/say-good-bye-view/say-good-bye-view.component";

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    WelcomeViewComponent,
    RouterOutlet,
    Box1Component,
    NewChatBotComponent,
    SayGoodByeViewComponent
],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export default class HomeComponent {
  private _router = inject(Router);
  private _activedRoute = inject(ActivatedRoute);
  private _chatbotScriptService = inject(ChatBotScriptService);
  private _websocketLaravelReverbService = inject(WebsocketLaravelReverb);
  private _customRouteService = inject(CustomRouteService);
  
  protected chatId = this._chatbotScriptService.chatId;
  private _routeToken =  this._customRouteService.token;

  constructor() {
    this._activedRoute.paramMap.subscribe(params => {
      const routeToken = params.get('routeToken');
      if (!routeToken) return;
      
      this._customRouteService.setToken(routeToken);
    });
  }
  
  protected checkIsBackButtonVisible(): boolean {
    const url = this._router.url;
    const match = /^\/home\/route\/[^\/]+$/.test(url);
    return !match;
  }
  
  protected goBack(): void {
    this._websocketLaravelReverbService
      .sendMessage(
        CHANNEL_ATRIL_PANTALLA_NAME, 
        GO_TO_HOME_PAGE_EVENT + this._routeToken(), 
        []
      );
    
    this._router.navigate(
      ['/home/route', this._routeToken()],
    );
  }
}
